

import Vue from 'vue'

import vuexI18n from 'vuex-i18n'
import router from './router'
import zh from './lang/zh.js'
import en from './lang/en.js'
import taiwan from './lang/taiwan.js'
import store from './store'
import md5 from 'js-md5'
import utils from './utils';
import VueCookie from 'vue-cookie';



utils.refreshRem();
window.addEventListener('resize', function() {
utils.refreshRem();
}, false);

var VueScrollTo = require('vue-scrollto');


import LocalePlugin from 'vux/src/plugins/locale/index.js'
import BusPlugin from 'vux/src/plugins/bus/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'


import App from './App'
require('es6-promise').polyfill()

const jumpReload = false;

Vue.prototype.$md5 = md5;
Vue.prototype.$url = 'https://api.gcpadi.com'




Vue.use(VueCookie);
Vue.use(LocalePlugin)
Vue.use(BusPlugin)
Vue.use(ToastPlugin);
Vue.use(vuexI18n.plugin, store);
Vue.use(DatetimePlugin)
Vue.use(VueScrollTo, {
container: "body",
duration: 500,
easing: "ease",
offset: -46,
force: true,
cancelable: true,
onStart: false,
onDone: false,
onCancel: false,
x: false,
y: true
})

window.$vue = Vue;
const finalLocales = {
'en': en,
'zh-CN': zh,
'taiwan': taiwan
}
for (let i in finalLocales) {
Vue.i18n.add(i, finalLocales[i])
}

const nowLocale = Vue.locale.get()
if (/en/.test(nowLocale)) {
Vue.i18n.set('en');
} else if (/taiwan/.test(nowLocale)) {
Vue.i18n.set('taiwan');
} else {
Vue.i18n.set('zh-CN')
}

Vue.config.productionTip = false;

const shouldUseTransition = !/transition=none/.test(location.href)

store.registerModule('vux', {
state: {
isLoading: false,
direction: shouldUseTransition ? 'forward' : ''
},
mutations: {
updateLoadingStatus(state, payload) {
state.isLoading = payload.isLoading
},
updateDirection(state, payload) {
if (!shouldUseTransition) {
return
}
state.direction = payload.direction
}
},
actions: {

}
})






































































router.afterEach(function() {

store.commit('updateLoadingStatus', {
isLoading: false
})
})


/* eslint-disable no-new */
new Vue({
store,
router,
render: h => h(App)
}).$mount('#app-box')


// WEBPACK FOOTER //
// ./src/main.js